<template>
	<div class="sanity-rich-text-component block--cta text-align-center my-100">
		<BaseLink classes="button button-primary body-md" :link="link" />
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Link } from 'types/layout';
import { PortableTextComponentProps } from '@portabletext/vue';
import { SanityRichTextCta } from 'types/sanity';

type Props = PortableTextComponentProps<SanityRichTextCta>;
const props = defineProps<Props>();

const link = computed((): Link => {
	return {
		text: props.value.linkText ?? '',
		href: props.value.url ?? '',
		target: props.value.openInNewTab ? '_blank' : ''
	};
});
</script>
